/* eslint-disable */
import domReady from "@wordpress/dom-ready";

domReady(() => {
  (function () {
    const newsletterBlocks = document.querySelectorAll(
      ".wp-block-do-blocks-newsletter-block"
    );

    if (newsletterBlocks.length > 0) {
      newsletterBlocks.forEach((item) => {
        const itemId = item.getAttribute("id");
        const form = document.querySelector(`#${itemId} #dco-newsletter-form`);

        if (!form) {
          return;
        }

        const emailInput = document.getElementById("dco-newsletter-form-email");
        const button = form.querySelector("button");
        const buttonText = button.innerText;
        const p = document.createElement("p");

        form.addEventListener("submit", function (e) {
          e.preventDefault();

          const xhr = new XMLHttpRequest();

          xhr.addEventListener("loadstart", function () {
            button.setAttribute("disabled", true);
            button.innerText = "Submitting";
          });

          xhr.addEventListener("load", function () {
            const data = JSON.parse(xhr.response);
            p.style.border = "1px solid #d6e9c6";
            p.style.backgroundColor = "#dff0d8";
            p.style.color = "#3c763d";
            p.style.padding = "1rem 1.5rem";
            p.style.marginTop = "1.25rem";
            p.style.borderRadius = "5px";
            p.style.fontSize = "1rem";

            if (data.mode == "new-subscribe") {
              p.innerText = "Thanks for subscribing!";
              emailInput.value = "";
              form.appendChild(p);
              setTimeout(() => p.remove(), 2000);
            } else if (data.mode == "already-subscribe") {
              p.innerText = data.message;
              emailInput.value = "";
              form.appendChild(p);
              setTimeout(() => p.remove(), 2000);
            }
          });

          xhr.addEventListener("error", function () {
            alert("Error!");
          });

          xhr.addEventListener("loadend", function () {
            button.removeAttribute("disabled");
            button.innerText = buttonText;
          });

          xhr.open(form.method, form.action);
          xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
          xhr.send(new FormData(form));
        });
      });
    }
  })();
});
